export default "__VITE_ASSET__BQEWsLN$__"